import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/ranking", label: "实时榜单" },
  { to: "/news", label: "最新资讯" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(keyword.trim() ? `/news?q=${encodeURIComponent(keyword.trim())}` : "/news");
    setOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? "bg-background-50/90 backdrop-blur-md border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="container-x flex h-16 items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0" aria-label="在线吃瓜 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="font-heading text-2xl leading-none tracking-wide">在线吃瓜</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <form onSubmit={onSearch} className="flex items-center gap-1 rounded-full bg-background-100 border border-background-200 pl-3 pr-1 py-1 focus-within:border-primary-300 transition-colors">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜热瓜关键词"
              className="bg-transparent outline-none text-sm w-28 lg:w-36 placeholder:text-foreground-400"
            />
            <button type="submit" aria-label="搜索" className="flex h-7 w-7 items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer">
              <i className="ri-arrow-right-line text-sm"></i>
            </button>
          </form>
          <Link to="/news" className="chip bg-accent-500 text-background-50 px-3 py-1.5 text-sm font-medium hover:bg-accent-600 transition-colors">
            <i className="ri-fire-line"></i>
            今日热瓜
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden flex h-10 w-10 items-center justify-center rounded-lg bg-background-100 border border-background-200"
          aria-label="展开菜单"
          aria-expanded={open}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4">
          <nav className="grid grid-cols-2 gap-2 pt-3" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-lg text-center text-sm font-medium ${
                    isActive ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <form onSubmit={onSearch} className="mt-3 flex items-center gap-2">
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜热瓜关键词"
              className="flex-1 rounded-lg bg-background-100 border border-background-200 px-3 py-2 text-sm outline-none focus:border-primary-300"
            />
            <button type="submit" className="chip bg-primary-500 text-background-50 px-4 py-2 text-sm">搜索</button>
          </form>
        </div>
      )}
    </header>
  );
}